import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  M_POST,
  CORE_URL,
  GET_USER_ONLINE,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'useronline' })
export default class Suggest extends VuexModule {
  userOnline: any = [];

  @Mutation
  mutateUserOnline(userOnline) {
    this.userOnline = userOnline;
  }

  @Action
  FetchPlayerOnline(language) {
    return Vue.axios({
      url: CORE_URL + GET_USER_ONLINE,
      method: M_POST,
      data: {},
      headers: {
        'Accept-Language': language,
      },
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const playerList = data.data;
          return playerList;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
